import { useState, useEffect } from "react";
import "./styles/payinfo.scss";
import Address from "./component/address";
import axios from "axios";
import { backend } from '../../components/apipath';
import { useAuth } from "../../pages/login/AuthProvider";
import { usePayment } from "../../components/PaymentContext";
import { useNavigate, useLocation } from "react-router-dom";

function Payinfo() {
  const { step, setStep } = usePayment();
  const [showCourses , setShowCourses] = useState(false);
  const { mem_id, authorized } = useAuth();
  const [isForeignAddress, setIsForeignAddress] = useState(false);
  const [isTEPB, setIsTEPB] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const eaBookOptions = [
    { id: "part1", label: "EA Part 1" },
    { id: "part2", label: "EA Part 2" },
    { id: "part3", label: "EA Part 3" },
  ];
  const PARENT_ID = {
    CPA: "1",
    CMA: "2",
    EA:  "3",
    CPE: "4",
    BRIDGE: "5",
    UT:  "6",
    RP:  "7",
    CIA:  "8",
    TEPB: "9",
  };

  // ===== 舊生續購：加購項目 options =====
  const cpaAddonOptions = [
    { id: "ua_extend_18000", label: "Unlimited Access 持續展延 - NT$18,000" },
    { id: "final_review_8000", label: "Becker CPA Final Review - 單科 NT$8,000" },
    { id: "chinese_course_1500", label: "中文課程 - 單堂3小時 NT$1,500" },
    { id: "consult_1500", label: "顧問諮詢 - 單次20分鐘 NT$1,500" },
    { id: "textbook_2500", label: "紙本 Becker 原文教科書 - 單本 NT$2,500 (請於備註欄註明數量、科目)" },
  ];

  // ===== 舊生續購：中文面授班科目 options =====
  const chineseInpersonSubjects = [
    { id: "FAR", label: "FAR" },
    { id: "AUD", label: "AUD" },
    { id: "REG", label: "REG" },
    { id: "BAR", label: "Discipline (BAR/ISC/TCP) - BAR" },
    { id: "ISC", label: "Discipline (BAR/ISC/TCP) - ISC" },
    { id: "TCP", label: "Discipline (BAR/ISC/TCP) - TCP" },
  ];

  // 產品父層
  const [parentId, setParentId] = useState("");
  // CPA 與 EA 都可選「現場面授」
  const [allowOnsite, setAllowOnsite] = useState(false);
  // 僅 CMA 需要顯示/驗證額外欄位
  const [isCMA, setIsCMA] = useState(false);
  const [isCPA, setIsCPA] = useState(false);
  const [isEA,  setIsEA]  = useState(false);
  const [isRP,  setIsRP]  = useState(false);
  const [isCIA, setIsCIA] = useState(false);

  // ===== 共用：日期解析/驗證 =====
  const parseYMD = (s = "") => {
    const m = s.trim().match(/^(\d{4})[-\/](\d{2})[-\/](\d{2})$/);
    if (!m) return null;
    const y = Number(m[1]), mo = Number(m[2]), d = Number(m[3]);
    const dt = new Date(Date.UTC(y, mo - 1, d));
    if (
      dt.getUTCFullYear() !== y ||
      dt.getUTCMonth() + 1 !== mo ||
      dt.getUTCDate() !== d
    ) return null;
    return { y, mo, d, date: dt };
  };

  const isValidDateInRange = (s, minISO, maxISO) => {
    const p = parseYMD(s);
    if (!p) return false;
    const x = p.date.getTime();
    const min = parseYMD(minISO)?.date.getTime();
    const max = parseYMD(maxISO)?.date.getTime();
    if (min != null && x < min) return false;
    if (max != null && x > max) return false;
    return true;
  };

  const addDaysISO = (baseISO, days) => {
    const p = parseYMD(baseISO);
    if (!p) return baseISO;
    const t = new Date(p.date.getTime());
    t.setUTCDate(t.getUTCDate() + days);
    const y = t.getUTCFullYear();
    const m = String(t.getUTCMonth() + 1).padStart(2, '0');
    const d = String(t.getUTCDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  };

  // 產品型別：BASIC(=CPA/CMA/EA)、CPE、BRIDGE、UT
  const [productType, setProductType] = useState("BASIC");

  // 學分班課程選單
  const [bridgeCourseOptions, setBridgeCourseOptions] = useState([]);

  //判斷EA方案欄位
  const EA_PARTIAL_PRODUCT_IDS = ["26", "27"];
  const selectedPlan = localStorage.getItem("selectedPlan") || "";
  const queryParams = new URLSearchParams(location.search);
  const productIdFromQuery = queryParams.get("product_id");

  const isCIASingleSelfStudy = isCIA && String(selectedPlan) === "28";
  const isEAPartial = EA_PARTIAL_PRODUCT_IDS.includes(String(selectedPlan));
  const EA_BOOK_PRODUCT_IDS = ["9"];
  const isEABookPlan = isEA && EA_BOOK_PRODUCT_IDS.includes(selectedPlan);
  const isEAPartialPlan = isEA && EA_PARTIAL_PRODUCT_IDS.includes(selectedPlan);
  // ===== 表單資料 =====
  const [formData, setFormData] = useState({
    name: "",
    fname: "",
    lname: "",
    email: "",
    phone: "",
    idIdentity: "",
    school: "",
    major: "",
    address: "",
    address_type: "TW",
    foreign_address: "",
    tax_num: "",
    company: "",
    status: "",
    jobtitle:"",
    workyear:"",
    reason: "",
    industry:"",
    deliver: [],
    course: [],
    book: [],
    info_way: [],

    // CPE
    cpe_email: "",
    cpe_activation_confirm: false,
    cpe_company_name: "",

    // BRIDGE
    bridge_birthdate: "",
    bridge_courses: [],

    // UT 專屬
    ut_activation_date: "",
    ut_reasons: [],

    // RP 專屬
    cpa_addons: [],
    chinese_class_option: "",
    chinese_inperson_subjects: [],

    // CIA
    cia_subjects: [],
    
    // TEPB
    tepb_reasons: [],
    tepb_reason_other: "",
    tepb_background: [],
    tepb_background_other: "",
    
    //EA
    ea_parts: [],
  });

  const [errors, setErrors] = useState({
    name: "",
    fname:"",
    lname:"",
    email: "",
    phone: "",
    idIdentity: "",
    school: "",
    major: "",
    address: "",
    foreign_address: "",
    status: "",
    jobtitle:"",
    workyear: "",
    reason: "",
    industry:"",
    deliver: "",
    course: "",
    book: "",
    info_way: "",
    tax_num: "",
    // CPE
    cpe_email: "",
    cpe_activation_confirm: "",
    cpe_company_name: "",
    // BRIDGE
    bridge_birthdate: "",
    bridge_courses: "",
    // UT
    ut_activation_date: "",
    ut_reasons: "",
    // ✅ TEPB
    tepb_reasons: "",
    tepb_reason_other: "",
    tepb_background: "",
    tepb_background_other: "",
    //RP
    chinese_class_option: "",
    chinese_inperson_subjects: "",
    //EA
    ea_parts: "",
    // CIA
    cia_subjects: "",
  });

  useEffect(() => {
  const searchParams = new URLSearchParams(location.search);
  const pidFromQuery = searchParams.get("parent_id");
  const pid = pidFromQuery || localStorage.getItem("selectedParentId") || "";

  if (pidFromQuery) {
    localStorage.setItem("selectedParentId", pidFromQuery);
  }

  setParentId(pid);

  const onsite = pid === PARENT_ID.CPA || pid === PARENT_ID.EA;
  setAllowOnsite(onsite);
  setIsCMA(pid === PARENT_ID.CMA);
  setIsCPA(pid === PARENT_ID.CPA);
  setIsEA(pid === PARENT_ID.EA);
  setIsRP(pid === PARENT_ID.RP);

  const cia = pid === PARENT_ID.CIA;
  setIsCIA(cia);

  const tepb = pid === PARENT_ID.TEPB;
  setIsTEPB(tepb);

  if (pid === PARENT_ID.CPE) setProductType("CPE");
  else if (pid === PARENT_ID.BRIDGE) setProductType("BRIDGE");
  else if (pid === PARENT_ID.UT) setProductType("UT");
  else if (pid === PARENT_ID.RP) setProductType("RP");
  else setProductType("BASIC");

  if (pid !== PARENT_ID.EA) {
    setShowCourses(false);
    setFormData(prev => {
      const next = {
        ...prev,
        book: [],
        deliver: [],
      };
      localStorage.setItem("formData", JSON.stringify(next));
      return next;
    });
  }

  if (!onsite && !tepb) {
    setFormData(prev => {
      const filtered = (Array.isArray(prev.course) ? prev.course : []).filter(
        v => v !== "現場面授" && v !== "實體現場教學" && v !== "線上直播教學"
      );
      const next = { ...prev, course: filtered };
      localStorage.setItem("formData", JSON.stringify(next));
      return next;
    });
  }
}, [location.search]);

    // ✅ TEPB：固定上課方式
    // if (tepb) {
    //   setFormData(prev => {
    //     const next = { ...prev, course: ["現場面授"] };
    //     localStorage.setItem("formData", JSON.stringify(next));
    //     return next;
    //   });
    // }
  

  // 取得學分班課程
  useEffect(() => {
    if (productType !== "BRIDGE") return;
    let cancelled = false;
    (async () => {
      try {
        const url = `${backend}course/csu-course`;
        const { data } = await axios.get(url);
        const rows = Array.isArray(data) ? data : (Array.isArray(data?.rows) ? data.rows : []);
        const opts = rows.map(d => ({
          id: String(d.id ?? d.csu_course_id ?? ""),
          label: `${d.code ?? ""} - ${(d.title ?? d.content ?? "").trim()}`
                + `${d.credit ? `（${Number(d.credit)} 學分）` : ""}`
                + `${d.cpa_range ? `｜${d.cpa_range}` : ""}`,
        })).filter(o => o.id && o.label);
        if (!cancelled) setBridgeCourseOptions(opts);
      } catch (e) {
        console.error("Failed to load csu courses", e);
        if (!cancelled) setBridgeCourseOptions([]);
      }
    })();
    return () => { cancelled = true; };
  }, [productType]);

  // 初始載入 localStorage.formData 合併
  useEffect(() => {
    
    
    const stored = JSON.parse(localStorage.getItem("formData") || "{}");
    setIsForeignAddress(String(stored.address_type || "TW").toUpperCase() === "FOREIGN");
    const hasEABookSelection =
          (Array.isArray(stored.deliver) && stored.deliver.length > 0) ||
          (Array.isArray(stored.book) && stored.book.length > 0);

        setShowCourses(hasEABookSelection);
    setFormData(prev => ({
      ...prev,
      ...stored,
      address_type: stored.address_type || "TW",
      cia_subjects: Array.isArray(stored.cia_subjects)
      ? stored.cia_subjects.filter(Boolean)
      : (typeof stored.cia_subjects === "string"
          ? stored.cia_subjects.split(",").map(s => s.trim()).filter(Boolean)
          : []),
      foreign_address: stored.foreign_address || "",
      course: Array.isArray(stored.course)
        ? stored.course.filter(Boolean)
        : (typeof stored.course === 'string' ? stored.course.split(',').map(s => s.trim()).filter(Boolean) : []),
      book: Array.isArray(stored.book)
        ? stored.book.filter(Boolean)
        : (typeof stored.book === 'string' ? stored.book.split(',').map(s => s.trim()).filter(Boolean) : []),
      deliver: Array.isArray(stored.deliver)
        ? stored.deliver.filter(Boolean)
        : (typeof stored.deliver === 'string' ? stored.deliver.split(',').map(s => s.trim()).filter(Boolean) : []),
      info_way: Array.isArray(stored.info_way)
        ? stored.info_way.filter(Boolean)
        : (typeof stored.info_way === 'string' ? stored.info_way.split(',').map(s => s.trim()).filter(Boolean) : []),

      ut_reasons: Array.isArray(stored.ut_reasons)
        ? stored.ut_reasons.filter(Boolean)
        : (typeof stored.ut_reasons === 'string' ? stored.ut_reasons.split(',').map(s => s.trim()).filter(Boolean) : []),

      cpa_addons: Array.isArray(stored.cpa_addons)
        ? stored.cpa_addons.filter(Boolean)
        : (typeof stored.cpa_addons === 'string' ? stored.cpa_addons.split(',').map(s => s.trim()).filter(Boolean) : []),

      chinese_inperson_subjects: Array.isArray(stored.chinese_inperson_subjects)
        ? stored.chinese_inperson_subjects.filter(Boolean)
        : (typeof stored.chinese_inperson_subjects === 'string' ? stored.chinese_inperson_subjects.split(',').map(s => s.trim()).filter(Boolean) : []),

      chinese_class_option: stored.chinese_class_option || "",

      // ✅ TEPB
      tepb_reasons: Array.isArray(stored.tepb_reasons)
        ? stored.tepb_reasons.filter(Boolean)
        : (typeof stored.tepb_reasons === 'string' ? stored.tepb_reasons.split(',').map(s => s.trim()).filter(Boolean) : []),
      tepb_reason_other: stored.tepb_reason_other || "",
      tepb_background: Array.isArray(stored.tepb_background)
        ? stored.tepb_background.filter(Boolean)
        : (typeof stored.tepb_background === 'string' ? stored.tepb_background.split(',').map(s => s.trim()).filter(Boolean) : []),
      tepb_background_other: stored.tepb_background_other || "",
    }));
  }, []);

  // 權限與流程檢查
  useEffect(() => {
    const selectedPlan = localStorage.getItem("selectedPlan");
    if (!authorized) {
      navigate("/member/memberlogin");
    } else if (step < 1 || !selectedPlan) {
      navigate("/registration");
    }
  }, [authorized, step, navigate]);

  // 讀會員資料預填
  useEffect(() => {
    const fetchMemberData = async () => {
      try {
        if (!mem_id) return;
        const response = await axios.get(`${backend}member/memareaData/${mem_id}`);
        if (response.data && response.data.length > 0) {
          const m = response.data[0];
          const t = String(m.address_type || "TW").toUpperCase();
          setIsForeignAddress(t === "FOREIGN");

          setFormData(prev => ({
            ...prev,
            name: m.chinese_name || "",
            fname: m.first_name || "",
            lname: m.last_name || "",
            email: m.email || "",
            phone: m.phone_num || "",
            school: m.school || "",
            major: m.major || "",
            address: m.address || "",
            address_type: (m.address_type || "TW"),
            foreign_address: m.foreign_address || "",
            status: m.status || "",
            idIdentity: m.id_num || "",
            workyear: m.workyear || "",
            jobtitle: m.jobtitle || "",
            industry: m.industry || "",
            reason: m.reason || "",
            course: Array.isArray(m.course)
              ? m.course
              : (typeof m.course === 'string' ? m.course.split(',').map(s => s.trim()).filter(Boolean) : []),
            info_way: Array.isArray(m.info_way)
              ? m.info_way
              : (typeof m.info_way === 'string' ? m.info_way.split(',').map(s => s.trim()).filter(Boolean) : []),
          }));

          localStorage.setItem("formData", JSON.stringify({
            ...JSON.parse(localStorage.getItem("formData") || "{}"),
            address: m.address || "",
            address_type: (m.address_type || "TW"),
            foreign_address: m.foreign_address || "",
          }));
        }
      } catch (error) {
        console.error("Failed to fetch member data", error);
      }
    };

    fetchMemberData();
  }, [mem_id]);

  // ========== 事件處理 ==========
  const handleCourseSelection = (e) => {
    const { value, checked } = e.target;
    setFormData(prev => {
      const now = new Set(prev.course || []);
      if (checked) now.add(value);
      else now.delete(value);
      const next = { ...prev, course: Array.from(now) };
      localStorage.setItem("formData", JSON.stringify(next));
      return next;
    });
  };

  const handleBookChange = (e) => {
    const value = e.target.value;
    setFormData(prev => {
      const prevBooks = Array.isArray(prev?.book) ? prev.book : [];
      const nextBooks = prevBooks.includes(value)
        ? prevBooks.filter(v => v !== value)
        : [...prevBooks, value];
      const next = { ...(prev || {}), book: nextBooks };
      localStorage.setItem("formData", JSON.stringify(next));
      return next;
    });
  };

  const handleAddBookToggle = (wantBooks) => {
    setShowCourses(wantBooks);
    setFormData(prev => {
      const prevObj = prev || {};
      const next = {
        ...prevObj,
        book: wantBooks ? (Array.isArray(prevObj.book) ? prevObj.book : []) : [],
        deliver: wantBooks ? (Array.isArray(prevObj.deliver) ? prevObj.deliver : []) : [],
      };
      localStorage.setItem("formData", JSON.stringify(next));
      return next;
    });
  };

  const handleDeliverChange = (value) => {
    setFormData(prev => {
      const next = { ...(prev || {}), deliver: [value] };
      localStorage.setItem("formData", JSON.stringify(next));
      return next;
    });
  };

  const handleinfoChange = (e) => {
    const { value, checked } = e.target;
    setFormData(prev => {
      const now = new Set(prev.info_way || []);
      if (checked) now.add(value);
      else now.delete(value);
      const next = { ...prev, info_way: Array.from(now) };
      localStorage.setItem("formData", JSON.stringify(next));
      return next;
    });
  };

  const handleBridgeCourseChange = (e) => {
    const { value, checked } = e.target;
    const id = String(value);
    setFormData(prev => {
      const now = new Set(prev.bridge_courses?.map(String) || []);
      if (checked) now.add(id);
      else now.delete(id);
      const next = { ...prev, bridge_courses: Array.from(now) };
      localStorage.setItem("formData", JSON.stringify(next));
      return next;
    });
  };

  const handleUTReasonChange = (e) => {
    const { value, checked } = e.target;
    setFormData(prev => {
      const now = new Set(prev.ut_reasons || []);
      if (checked) now.add(value);
      else now.delete(value);
      const next = { ...prev, ut_reasons: Array.from(now) };
      localStorage.setItem("formData", JSON.stringify(next));
      return next;
    });
  };

  const handleCpaAddonChange = (e) => {
    const value = String(e.target.value);
    const checked = e.target.checked;
    setFormData(prev => {
      const now = new Set((prev.cpa_addons || []).map(String));
      if (checked) now.add(value);
      else now.delete(value);
      const next = { ...prev, cpa_addons: Array.from(now) };
      localStorage.setItem("formData", JSON.stringify(next));
      return next;
    });
  };

  const handleChineseClassOptionChange = (e) => {
    const option = e.target.value;
    setFormData(prev => {
      const next = {
        ...prev,
        chinese_class_option: option,
        chinese_inperson_subjects: option === "inperson" ? (prev.chinese_inperson_subjects || []) : [],
      };
      localStorage.setItem("formData", JSON.stringify(next));
      return next;
    });
  };

  const handleChineseInpersonSubjectChange = (e) => {
    const value = String(e.target.value);
    const checked = e.target.checked;
    setFormData(prev => {
      const now = new Set((prev.chinese_inperson_subjects || []).map(String));
      if (checked) now.add(value);
      else now.delete(value);
      const next = { ...prev, chinese_inperson_subjects: Array.from(now) };
      localStorage.setItem("formData", JSON.stringify(next));
      return next;
    });
  };

  // ✅ TEPB handlers
  const handleTEPBReasonChange = (e) => {
    const { value, checked } = e.target;
    setFormData(prev => {
      const now = new Set(prev.tepb_reasons || []);
      if (checked) now.add(value);
      else now.delete(value);

      const next = { ...prev, tepb_reasons: Array.from(now) };
      if (!next.tepb_reasons.includes("其他")) next.tepb_reason_other = "";
      localStorage.setItem("formData", JSON.stringify(next));
      return next;
    });
  };

  const handleTEPBBackgroundChange = (e) => {
    const { value, checked } = e.target;
    setFormData(prev => {
      const now = new Set(prev.tepb_background || []);
      if (checked) now.add(value);
      else now.delete(value);

      const next = { ...prev, tepb_background: Array.from(now) };
      if (!next.tepb_background.includes("其他")) next.tepb_background_other = "";
      localStorage.setItem("formData", JSON.stringify(next));
      return next;
    });
  };

  const validateTWID = (id) => {
    const letters = 'ABCDEFGHJKLMNPQRSTUVXYWZIO';
    const regex = /^[A-Z][12]\d{8}$/;
    if (!regex.test(id)) return false;
    const firstLetter = id.charAt(0);
    const index = letters.indexOf(firstLetter) + 10;
    const n1 = Math.floor(index / 10);
    const n2 = index % 10;
    const numbers = [n1, n2, ...id.substr(1).split('').map(Number)];
    const weights = [1, 9, 8, 7, 6, 5, 4, 3, 2, 1, 1];
    let sum = 0;
    for (let i = 0; i < numbers.length; i++) sum += numbers[i] * weights[i];
    return sum % 10 === 0;
  };

  const handleForeignToggle = (checked) => {
    setIsForeignAddress(checked);

    setFormData((prev) => {
      const next = { ...prev };
      next.address_type = checked ? "FOREIGN" : "TW";

      if (checked) {
        next.address = "";
        next.deliver = [];
      } else {
        next.foreign_address = "";
      }

      localStorage.setItem("formData", JSON.stringify(next));
      return next;
    });
  };

  // ===== UT 選項清單 =====
  const UT_REASONS = [
    { val: "prep_cpa", label: "為未來準備美國 CPA 考試做預習" },
    { val: "prep_ea",  label: "為未來準備美國 EA 考試做預習" },
    { val: "work_fast",label: "工作與美稅有關，希望短期快速理解美稅全盤概念" },
    { val: "interest", label: "對美國稅務有興趣，希望自學充實相關知識" },
  ];

  // ✅ TEPB options
  const TEPB_REASONS = [
    "不確定自己過去的美國稅務申報是否完整",
    "想了解如果過去漏報海外資產或收入，現在應該如何補報（Streamlined Filing）",
    "想了解 FBAR / FATCA 等海外帳戶申報規定",
    "有海外投資或資產，希望了解跨境稅務影響",
    "家庭有美國身分成員，想了解資產配置或傳承問題",
    "在美國設立公司，希望了解公司相關申報義務",
    "想了解收到 IRS 通知（如 CP2000）時應如何應對",
    "想建立完整的美國跨境稅務申報架構",
    "希望提升跨境稅務專業能力（會計／保險／稅務從業者）",
    "其他",
  ];

  const TEPB_BACKGROUNDS = [
    "台美雙籍人士 / 美國公民或綠卡持有人",
    "台灣創業者（設立美國公司）",
    "高資產家庭與跨境資產配置者",
    "保險從業人員",
    "美國註冊會計師",
    "美國註冊稅務顧問",
    "其他",
  ];

  const CIA_SINGLE_SUBJECTS = [
    "CIA Review Part 1 - Internal Audit Fundamentals",
    "CIA Review Part 2 - Internal Audit Engagement",
    "CIA Review Part 3 - Internal Audit Function",
  ];

  // 送出
  const handleSubmit = async (e) => {
    e.preventDefault();

    let formValid = true;
    const newErrors = {};
    const chineseNameRegex = /^[\u4e00-\u9fa5]{2,}$/;
    const englishNameRegex = /^[a-zA-Z\s\-]+$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^(\+?886\-?|0)?9\d{8}$/;
    const taxIdRegex = /^\d{8}$/;

    // ✅ 基本必填（TEPB 會移除英名/身分證/學校）
   const requiredBase = (isTEPB || isCIASingleSelfStudy)
  ? ["name", "fname", "lname", "email", "phone", "school", "major", "status", "info_way"]
  : ["name", "fname", "lname", "email", "phone", "idIdentity", "school", "major", "status", "info_way"];

    requiredBase.forEach((field) => {
      const val = formData[field];
      if (!val || (Array.isArray(val) && val.length === 0)) {
        newErrors[field] = "此欄位是必填欄位";
        formValid = false;
      }
    });

    const isCourier = Array.isArray(formData.deliver) && formData.deliver.includes("快遞");
    if (parentId === PARENT_ID.EA && showCourses && isCourier) {
      if (!Array.isArray(formData.book) || formData.book.length === 0) {
        newErrors.book = "請選擇快遞書本";
        formValid = false;
      }
    }

    // 上課方式必填（TEPB 固定，不走這段）
    if (!isCIA && productType !== "CPE" && (!Array.isArray(formData.course) || formData.course.length === 0)) {
      newErrors.course = "請選擇上課方式";
      formValid = false;
    }

    // CMA 額外必填（沿用原設計）
    if (productType === "BASIC" && isCMA) {
      if (!formData.workyear) { newErrors.workyear = "請填寫工作年資"; formValid = false; }
      if (!formData.reason)   { newErrors.reason   = "請填寫考照原因"; formValid = false; }
      if (!formData.jobtitle) { newErrors.jobtitle = "請填寫在職者職稱"; formValid = false; }
      if (!formData.industry) { newErrors.industry = "請填寫所屬產業"; formValid = false; }
    }

    // CPE 額外必填
    if (productType === "CPE") {
      // if (!formData.cpe_activation_confirm) {
      //   newErrors.cpe_activation_confirm = "請勾選已了解啟用說明";
      //   formValid = false;
      // }
      if (!formData.cpe_company_name || formData.cpe_company_name.trim() === "") {
        newErrors.cpe_company_name = "請填寫所屬公司行號名稱";
        formValid = false;
      }
    }

    // BRIDGE 額外必填
    if (productType === "BRIDGE") {
      const bday = (formData.bridge_birthdate || '').trim();
      const todayISO = new Date().toISOString().slice(0, 10);
      const minISO = "1900-01-01";
      if (!isValidDateInRange(bday, minISO, todayISO)) {
        newErrors.bridge_birthdate = "請輸入日期";
        formValid = false;
      }
      if (!Array.isArray(formData.bridge_courses) || formData.bridge_courses.length === 0) {
        newErrors.bridge_courses = "請至少選擇一個學分班課程";
        formValid = false;
      }
    }

    // UT 額外必填
    if (productType === "UT") {
      const todayISO = new Date().toISOString().slice(0, 10);
      const maxISO = addDaysISO(todayISO, 30);
      const utDate = (formData.ut_activation_date || '').trim();
      if (!utDate) {
        newErrors.ut_activation_date = "請指定啟用日";
        formValid = false;
      } else if (!isValidDateInRange(utDate, todayISO, maxISO)) {
        newErrors.ut_activation_date = `啟用日需為 ${todayISO} 至 ${maxISO} 之間`;
        formValid = false;
      }

      if (!Array.isArray(formData.ut_reasons) || formData.ut_reasons.length === 0) {
        newErrors.ut_reasons = "請至少勾選一項選購原因";
        formValid = false;
      }
    }

    // RP 額外必填（保留）
    if (productType === "RP") {
      if (!formData.chinese_class_option) {
        newErrors.chinese_class_option = "請選擇中文課程方式";
        formValid = false;
      }

      if (formData.chinese_class_option === "inperson") {
        if (!Array.isArray(formData.chinese_inperson_subjects) || formData.chinese_inperson_subjects.length === 0) {
          newErrors.chinese_inperson_subjects = "請至少勾選一個欲加入中文面授班的科目";
          formValid = false;
        }
      }
    }

    //EA必填
    if (isEAPartial) {
      if (!Array.isArray(formData.ea_parts) || formData.ea_parts.length === 0) {
        newErrors.ea_parts = "請至少選擇一個購買科目";
        formValid = false;
      }
    }

    // ✅ 地址驗證：TEPB 移除整題，所以不驗證
    if (!isTEPB) {
      if (isForeignAddress) {
        if (!formData.foreign_address || formData.foreign_address.trim().length < 3) {
          newErrors.foreign_address = "請輸入國外完整地址";
          formValid = false;
        }
      } else {
        if (!formData.address || formData.address.trim() === "") {
          newErrors.address = "此欄位是必填欄位";
          formValid = false;
        }
      }
    }

    // CIA 單科自修方案必填
    if (isCIASingleSelfStudy) {
      if (!Array.isArray(formData.cia_subjects) || formData.cia_subjects.length === 0) {
        newErrors.cia_subjects = "請至少選擇一門科目";
        formValid = false;
      }
    }

    // 其餘格式驗證
    if (formData.name && !chineseNameRegex.test(formData.name.trim())) {
      newErrors.name = "請輸入 2 個以上的中文姓名";
      formValid = false;
    }

    // ✅ TEPB CIA：英名/身分證不需要
    if (!isTEPB && !isCIASingleSelfStudy) {
      if (formData.fname && !englishNameRegex.test(formData.fname.trim())) {
        newErrors.fname = "First name 請輸入英文";
        formValid = false;
      }
      if (formData.lname && !englishNameRegex.test(formData.lname.trim())) {
        newErrors.lname = "Last name 請輸入英文";
        formValid = false;
      }
      if (formData.idIdentity && !validateTWID(formData.idIdentity.trim())) {
        newErrors.idIdentity = "請輸入正確的身分證號碼";
        formValid = false;
      }
    }

    if (formData.email && !emailRegex.test(formData.email.trim())) {
      newErrors.email = "請輸入正確的信箱";
      formValid = false;
    }
    if (formData.phone && !phoneRegex.test(formData.phone.trim())) {
      newErrors.phone = "請輸入正確的手機號碼";
      formValid = false;
    }
    if (formData.tax_num && !taxIdRegex.test(formData.tax_num)) {
      newErrors.tax_num = "統一編號需為 8 位數字";
      formValid = false;
    }

    // ✅ TEPB 新題目驗證
    if (isTEPB) {
      if (!Array.isArray(formData.tepb_reasons) || formData.tepb_reasons.length === 0) {
        newErrors.tepb_reasons = "請至少勾選一項原因";
        formValid = false;
      }
      if (formData.tepb_reasons?.includes("其他") && !(formData.tepb_reason_other || "").trim()) {
        newErrors.tepb_reason_other = "請填寫其他原因";
        formValid = false;
      }

      if (!Array.isArray(formData.tepb_background) || formData.tepb_background.length === 0) {
        newErrors.tepb_background = "請至少勾選一項背景身份";
        formValid = false;
      }
      if (formData.tepb_background?.includes("其他") && !(formData.tepb_background_other || "").trim()) {
        newErrors.tepb_background_other = "請填寫其他身份";
        formValid = false;
      }
    }

    const mergeTepbOptions = (selected = [], otherValue = "") => {
      const arr = Array.isArray(selected) ? selected.filter(item => item !== "其他") : [];
      if (Array.isArray(selected) && selected.includes("其他") && otherValue.trim()) {
        arr.push(otherValue.trim());
      }
      return arr.join("、");
    };

    const finalTepbReason = mergeTepbOptions(
      formData.tepb_reasons,
      formData.tepb_reason_other
    );

    const finalTepbBackground = mergeTepbOptions(
      formData.tepb_background,
      formData.tepb_background_other
    );
    setErrors(newErrors);
    if (!formValid) return;

    // 儲存到 localStorage
    const normalizedForm = {
      ...formData,
      ...(productType === "CPE" ? { cpe_email: formData.email || "" } : {}),
    };
    localStorage.setItem("formData", JSON.stringify(normalizedForm));

    // 傳給後端（只更新 mem 固定欄位即可；其餘欄位後端忽略沒關係）
    const payload = {
      ...normalizedForm,
      mem_id,
      course: Array.isArray(formData.course) ? formData.course.join(",") : "",
      info_way: Array.isArray(formData.info_way) ? formData.info_way.join(",") : "",
      bridge_courses: Array.isArray(formData.bridge_courses) ? formData.bridge_courses.join(",") : "",
      ut_reasons: Array.isArray(formData.ut_reasons) ? formData.ut_reasons.join(",") : "",
      product_type: productType,
      cpa_addons: Array.isArray(formData.cpa_addons) ? formData.cpa_addons.join(",") : "",
      chinese_class_option: formData.chinese_class_option || "",
      chinese_inperson_subjects: Array.isArray(formData.chinese_inperson_subjects) ? formData.chinese_inperson_subjects.join(",") : "",
      cia_subjects: Array.isArray(formData.cia_subjects)
      ? formData.cia_subjects.join(",")
      : "",
      // ✅ TEPB
      tepb_reason: finalTepbReason,
      tepb_background: finalTepbBackground,
    };

    try {
      await axios.post(`${backend}member/payinfo`, payload, {
        headers: { "Content-Type": "application/json" },
      });
      setStep(3);
      localStorage.setItem("paymentStep", "3");
      navigate("/registration/pay", { replace: true });
    } catch (error) {
      console.error("更新會員資料失敗：", error.response?.data || error.message);
    }
  };

  return (
    <>
      <div className="container mb100 mt100">
        <div className="beckertitlename mt100 mb-5">請填購買資料</div>
        <div className="card w-75 p-5 m-auto">
          <div className="card-body">
            <form>
              {/* ===== 基本資料 ===== */}
              <div className="form-group mb-4">
                <label htmlFor="name" className="mb-2">*中文全名</label>
                <input
                  className={`form-control ${errors.name && "is-invalid"}`}
                  type="text"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                />
                {errors.name && <div className="invalid-feedback">{errors.name}</div>}
              </div>

              {/* ✅ TEPB 要移除：英文拼音全名 */}
              {!isTEPB && (
                <div className="form-group mb-4">
                  <label className="mb-2">*英文拼音全名</label><br />
                  <div className="row">
                    <div className="col">
                      <input
                        type="text"
                        className={`form-control ${errors.fname && "is-invalid"}`}
                        placeholder="First name"
                        value={formData.fname}
                        onChange={(e) => setFormData({ ...formData, fname: e.target.value })}
                      />
                      {errors.fname && <div className="invalid-feedback">{errors.fname}</div>}
                    </div>
                    <div className="col">
                      <input
                        type="text"
                        className={`form-control ${errors.lname && "is-invalid"}`}
                        placeholder="Last name"
                        value={formData.lname}
                        onChange={(e) => setFormData({ ...formData, lname: e.target.value })}
                      />
                      {errors.lname && <div className="invalid-feedback">{errors.lname}</div>}
                    </div>
                  </div>
                  <small id="enameHelp" className="form-text text-muted">同護照上顯示之英文名，例：Da-Ming, Wang</small>
                </div>
              )}

              <div className="form-group mb-4">
                <label htmlFor="phone" className="mb-2">*聯絡電話</label>
                <input
                  type="tel"
                  className={`form-control ${errors.phone && "is-invalid"}`}
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                />
                {errors.phone && <div className="invalid-feedback">{errors.phone}</div>}
              </div>

              <div className="form-group mb-4">
                <label htmlFor="email" className="mb-2">*電子郵件</label>
                <input
                  type="email"
                  className={`form-control ${errors.email && "is-invalid"}`}
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                />
                {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                {productType !== "CPE" && (
                  <small id="emailHelp" className="form-text text-muted">
                    將依此註冊您的 Becker 教材帳號。若您曾經購買或試用過任何 Becker 產品，請提供「尚未用來註冊過 Becker」的電子郵件住址
                  </small>
                )}
              </div>

              {/* ✅ TEPB 要移除：身分證字號 */}
              {!isTEPB && !isCIASingleSelfStudy && (
                <div className="form-group mb-4">
                  <label htmlFor="idIdentity" className="mb-2">*身分證字號</label>
                  <input
                    type="text"
                    className={`form-control ${errors.idIdentity && "is-invalid"}`}
                    id="idIdentity"
                    name="idIdentity"
                    value={formData.idIdentity}
                    onChange={(e) => setFormData({ ...formData, idIdentity: e.target.value })}
                  />
                  {errors.idIdentity && <div className="invalid-feedback">{errors.idIdentity}</div>}
                  {!isCIA && (<small id="idHelp" className="form-text text-muted">將依此註冊您的中文「雲端導讀與解題」觀看帳號</small>)}
                </div>
              )}

              {/* ✅ TEPB 要移除：學校/科系 */}
              {!isTEPB && (
                <>
                  <div className="form-group mb-4">
                    <label htmlFor="school" className="mb-2">*所屬(或畢業)學校</label>
                    <input
                      type="text"
                      className={`form-control ${errors.school && "is-invalid"}`}
                      id="school"
                      value={formData.school}
                      onChange={(e) => setFormData({ ...formData, school: e.target.value })}
                    />
                    {errors.school && <div className="invalid-feedback">{errors.school}</div>}
                  </div>

                  <div className="form-group mb-4">
                    <label htmlFor="major" className="mb-2">*科系</label>
                    <input
                      type="text"
                      className={`form-control ${errors.major && "is-invalid"}`}
                      id="major"
                      value={formData.major}
                      onChange={(e) => setFormData({ ...formData, major: e.target.value })}
                    />
                    {errors.major && <div className="invalid-feedback">{errors.major}</div>}
                  </div>
                </>
              )}

              <div className="form-group mb-4">
                <label className="mb-2">*目前職業</label>
                <select
                  className={`form-control ${errors.status && "is-invalid"}`}
                  value={formData.status}
                  onChange={(e) => setFormData({ ...formData, status: e.target.value })}
                >
                  <option value="" disabled>請選擇職業</option>
                  <option value="incumbent">在職者</option>
                  <option value="student">在學生</option>
                  <option value="candidates">全職考生</option>
                  <option value="unemployed">待業中</option>
                  <option value="army">服役中</option>
                </select>
                {errors.status && <div className="invalid-feedback">{errors.status}</div>}
              </div>
              {productType === "RP" && (
                <>
                  <div className="form-group mb-4">
                    <label className="mb-2">加購項目（可複選）</label>
                    <div className="custom-control custom-checkbox mb-2">
                      {cpaAddonOptions.map((item) => (
                        <div key={item.id} className="form-check">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id={`rp-addon-${item.id}`}
                            value={item.id}
                            checked={
                              Array.isArray(formData.cpa_addons) &&
                              formData.cpa_addons.includes(item.id)
                            }
                            onChange={handleCpaAddonChange}
                          />
                          <label
                            className="custom-control-label m-2"
                            htmlFor={`rp-addon-${item.id}`}
                          >
                            {item.label}
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="form-group mb-4">
                    <label className="mb-2">*中文課程方式</label>
                    <div>
                      <div className="form-check form-check-inline">
                        <input
                          type="radio"
                          className="form-check-input"
                          id="rp-chinese-online"
                          name="rpChineseClassOption"
                          value="online"
                          checked={formData.chinese_class_option === "online"}
                          onChange={handleChineseClassOptionChange}
                        />
                        <label className="form-check-label" htmlFor="rp-chinese-online">
                          雲端教室
                        </label>
                      </div>

                      <div className="form-check form-check-inline">
                        <input
                          type="radio"
                          className="form-check-input"
                          id="rp-chinese-inperson"
                          name="rpChineseClassOption"
                          value="inperson"
                          checked={formData.chinese_class_option === "inperson"}
                          onChange={handleChineseClassOptionChange}
                        />
                        <label className="form-check-label" htmlFor="rp-chinese-inperson">
                          中文面授班
                        </label>
                      </div>
                    </div>

                    {errors.chinese_class_option && (
                      <div className="text-danger mt-1" style={{ fontSize: "0.9rem" }}>
                        {errors.chinese_class_option}
                      </div>
                    )}
                  </div>

                  {formData.chinese_class_option === "inperson" && (
                    <div className="form-group mb-4">
                      <label className="mb-2">*欲加入中文面授班的科目（可複選）</label>
                      <div className="custom-control custom-checkbox mb-2">
                        {chineseInpersonSubjects.map((item) => (
                          <div key={item.id} className="form-check">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id={`rp-subject-${item.id}`}
                              value={item.id}
                              checked={
                                Array.isArray(formData.chinese_inperson_subjects) &&
                                formData.chinese_inperson_subjects.includes(item.id)
                              }
                              onChange={handleChineseInpersonSubjectChange}
                            />
                            <label
                              className="custom-control-label m-2"
                              htmlFor={`rp-subject-${item.id}`}
                            >
                              {item.label}
                            </label>
                          </div>
                        ))}
                      </div>

                      {errors.chinese_inperson_subjects && (
                        <div className="text-danger mt-1" style={{ fontSize: "0.9rem" }}>
                          {errors.chinese_inperson_subjects}
                        </div>
                      )}
                    </div>
                  )}
                </>
              )}
              {productType === "UT" && (
                <>
                  <div className="form-group mb-4">
                    <label className="mb-2">*指定啟用日</label>
                    <input
                      type="date"
                      className={`form-control ${errors.ut_activation_date ? "is-invalid" : ""}`}
                      value={formData.ut_activation_date || ""}
                      onChange={(e) => {
                        const next = { ...formData, ut_activation_date: e.target.value };
                        setFormData(next);
                        localStorage.setItem("formData", JSON.stringify(next));
                      }}
                    />
                    <small className="form-text text-muted">
                      啟用日需為今天起 30 天內
                    </small>
                    {errors.ut_activation_date && (
                      <div className="invalid-feedback">{errors.ut_activation_date}</div>
                    )}
                  </div>

                  <div className="form-group mb-4">
                    <label className="mb-2">*選購原因（可複選）</label>
                    <div className="custom-control custom-checkbox mb-2">
                      {UT_REASONS.map((item) => (
                        <div key={item.val} className="form-check">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id={`ut-reason-${item.val}`}
                            value={item.val}
                            checked={Array.isArray(formData.ut_reasons) && formData.ut_reasons.includes(item.val)}
                            onChange={handleUTReasonChange}
                          />
                          <label
                            className="custom-control-label m-2"
                            htmlFor={`ut-reason-${item.val}`}
                          >
                            {item.label}
                          </label>
                        </div>
                      ))}
                    </div>

                    {errors.ut_reasons && (
                      <div className="text-danger mt-1" style={{ fontSize: "0.9rem" }}>
                        {errors.ut_reasons}
                      </div>
                    )}
                  </div>
                </>
              )}
              {productType === "CPE" && (
                <>
                  <div className="form-group mb-4">
                    <label className="mb-2">*所屬公司行號名稱</label>
                    <input
                      type="text"
                      className={`form-control ${errors.cpe_company_name ? "is-invalid" : ""}`}
                      value={formData.cpe_company_name || ""}
                      onChange={(e) => {
                        const next = { ...formData, cpe_company_name: e.target.value };
                        setFormData(next);
                        localStorage.setItem("formData", JSON.stringify(next));
                      }}
                    />
                    {errors.cpe_company_name && (
                      <div className="invalid-feedback">{errors.cpe_company_name}</div>
                    )}
                  </div>
                </>
              )}
              {productType === "BRIDGE" && (
                <>
                  <div className="form-group mb-4">
                    <label className="mb-2">*出生日期</label>
                    <input
                      type="date"
                      className={`form-control ${errors.bridge_birthdate ? "is-invalid" : ""}`}
                      value={formData.bridge_birthdate || ""}
                      onChange={(e) => {
                        const next = { ...formData, bridge_birthdate: e.target.value };
                        setFormData(next);
                        localStorage.setItem("formData", JSON.stringify(next));
                      }}
                    />
                    {errors.bridge_birthdate && (
                      <div className="invalid-feedback">{errors.bridge_birthdate}</div>
                    )}
                  </div>

                  <div className="form-group mb-4">
                    <label className="mb-2">*請選擇學分班課程</label>
                    <div className="custom-control custom-checkbox mb-2">
                      {bridgeCourseOptions.length > 0 ? (
                        bridgeCourseOptions.map((item) => (
                          <div key={item.id} className="form-check">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id={`bridge-course-${item.id}`}
                              value={item.id}
                              checked={
                                Array.isArray(formData.bridge_courses) &&
                                formData.bridge_courses.map(String).includes(String(item.id))
                              }
                              onChange={handleBridgeCourseChange}
                            />
                            <label
                              className="custom-control-label m-2"
                              htmlFor={`bridge-course-${item.id}`}
                            >
                              {item.label}
                            </label>
                          </div>
                        ))
                      ) : (
                        <div className="text-muted">目前沒有可選課程</div>
                      )}
                    </div>

                    {errors.bridge_courses && (
                      <div className="text-danger mt-1" style={{ fontSize: "0.9rem" }}>
                        {errors.bridge_courses}
                      </div>
                    )}
                  </div>
                </>
              )}
              {/* ✅ TEPB 新題目 */}
              {isTEPB && (
                <>
                  <hr />
                  <div className="form-group mb-4">
                    <label className="mb-2">*選購課程的原因（可複選）</label>
                    <div className="custom-control custom-checkbox mb-2">
                      {TEPB_REASONS.map((label, idx) => (
                        <div key={idx} className="form-check">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id={`tepb-reason-${idx}`}
                            value={label}
                            checked={Array.isArray(formData.tepb_reasons) && formData.tepb_reasons.includes(label)}
                            onChange={handleTEPBReasonChange}
                          />
                          <label className="custom-control-label m-2" htmlFor={`tepb-reason-${idx}`}>
                            {label === "其他" ? "其他：" : label}
                          </label>
                        </div>
                      ))}
                    </div>

                    {formData.tepb_reasons?.includes("其他") && (
                      <input
                        type="text"
                        className={`form-control ${errors.tepb_reason_other && "is-invalid"}`}
                        placeholder="請簡述其他原因"
                        value={formData.tepb_reason_other || ""}
                        onChange={(e) => {
                          const next = { ...formData, tepb_reason_other: e.target.value };
                          setFormData(next);
                          localStorage.setItem("formData", JSON.stringify(next));
                        }}
                      />
                    )}

                    {errors.tepb_reasons && <div className="text-danger mt-1">{errors.tepb_reasons}</div>}
                    {errors.tepb_reason_other && <div className="text-danger mt-1">{errors.tepb_reason_other}</div>}
                  </div>

                  <div className="form-group mb-4">
                    <label className="mb-2">*參與課程的背景身份（可複選）</label>
                    <div className="custom-control custom-checkbox mb-2">
                      {TEPB_BACKGROUNDS.map((label, idx) => (
                        <div key={idx} className="form-check">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id={`tepb-bg-${idx}`}
                            value={label}
                            checked={Array.isArray(formData.tepb_background) && formData.tepb_background.includes(label)}
                            onChange={handleTEPBBackgroundChange}
                          />
                          <label className="custom-control-label m-2" htmlFor={`tepb-bg-${idx}`}>
                            {label === "其他" ? "其他：" : label}
                          </label>
                        </div>
                      ))}
                    </div>

                    {formData.tepb_background?.includes("其他") && (
                      <input
                        type="text"
                        className={`form-control ${errors.tepb_background_other && "is-invalid"}`}
                        placeholder="請註明其他身份"
                        value={formData.tepb_background_other || ""}
                        onChange={(e) => {
                          const next = { ...formData, tepb_background_other: e.target.value };
                          setFormData(next);
                          localStorage.setItem("formData", JSON.stringify(next));
                        }}
                      />
                    )}

                    {errors.tepb_background && <div className="text-danger mt-1">{errors.tepb_background}</div>}
                    {errors.tepb_background_other && <div className="text-danger mt-1">{errors.tepb_background_other}</div>}
                  </div>
                  <div className="form-group mb-4">
                    <label className="mb-2">*選擇上課方式：</label>

                    <div className="custom-control custom-checkbox mb-2">
                      <div className="form-check form-check-inline">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          id="tepb-onsite"
                          value="實體現場教學"
                          checked={
                            Array.isArray(formData.course) &&
                            formData.course.includes("實體現場教學")
                          }
                          onChange={handleCourseSelection}
                        />
                        <label className="custom-control-label m-2" htmlFor="tepb-onsite">
                          實體現場教學
                        </label>
                      </div>

                      <div className="form-check form-check-inline">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          id="tepb-live"
                          value="線上直播教學"
                          checked={
                            Array.isArray(formData.course) &&
                            formData.course.includes("線上直播教學")
                          }
                          onChange={handleCourseSelection}
                        />
                        <label className="custom-control-label m-2" htmlFor="tepb-live">
                          線上直播教學
                        </label>
                      </div>
                    </div>

                    {errors.course && (
                      <div className="text-danger mt-1" style={{ fontSize: "0.9rem" }}>
                        {errors.course}
                      </div>
                    )}
                  </div>
                  
                </>
              )}

              {/* ===== CMA 額外欄位（沿用） ===== */}
              {isCMA && (
                <>
                  <div className="form-group mb-4">
                    <label className="mb-2">*所屬產業</label>
                    <select
                      className={`form-control ${errors.industry && "is-invalid"}`}
                      value={formData.industry}
                      onChange={(e) => setFormData({ ...formData, industry: e.target.value })}
                    >
                      <option value="" disabled>請選擇職業</option>
                      <option value="student">在學中，尚無所屬產業</option>
                      <option value="account">會計師事務所</option>
                      <option value="investment">投資銀行業</option>
                      <option value="financial">其他金融業</option>
                      <option value="manufacturing">製造業</option>
                      <option value="electronics">電子業</option>
                      <option value="other">其他</option>
                    </select>
                    {errors.industry && <div className="invalid-feedback">{errors.industry}</div>}
                  </div>

                  <div className="form-group mb-4">
                    <label className="mb-2">*在職者工作年資</label>
                    <input
                      type="text"
                      className={`form-control ${errors.workyear && "is-invalid"}`}
                      id="workyear"
                      placeholder="若仍為學生，請填「0」"
                      value={formData.workyear}
                      onChange={(e) => setFormData({ ...formData, workyear: e.target.value })}
                    />
                    {errors.workyear && <div className="invalid-feedback">{errors.workyear}</div>}
                  </div>

                  <div className="form-group mb-4">
                    <label className="mb-2">*在職者職稱</label>
                    <input
                      type="text"
                      className={`form-control ${errors.jobtitle && "is-invalid"}`}
                      id="jobtitle"
                      placeholder="若為在學生，請填 n/a。"
                      value={formData.jobtitle}
                      onChange={(e) => setFormData({ ...formData, jobtitle: e.target.value })}
                    />
                    {errors.jobtitle && <div className="invalid-feedback">{errors.jobtitle}</div>}
                  </div>

                  {productType !== "CPE" && (
                    <div className="form-group mb-4">
                      <label className="mb-2">*取得認證之職涯規劃</label>
                      <input
                        type="text"
                        className={`form-control ${errors.reason && "is-invalid"}`}
                        id="reason"
                        placeholder="請簡述考取證照的原因。"
                        value={formData.reason}
                        onChange={(e) => setFormData({ ...formData, reason: e.target.value })}
                      />
                      {errors.reason && <div className="invalid-feedback">{errors.reason}</div>}
                    </div>
                  )}
                </>
              )}
              {/* CIA */}
              {isCIASingleSelfStudy && (
                <div className="form-group mb-4">
                  <label className="mb-2">*請選擇您預購買的單門科目：</label>

                  <div className="custom-control custom-checkbox mb-2">
                    {CIA_SINGLE_SUBJECTS.map((label, idx) => (
                      <div key={idx} className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id={`cia-subject-${idx}`}
                          value={label}
                          checked={
                            Array.isArray(formData.cia_subjects) &&
                            formData.cia_subjects.includes(label)
                          }
                          onChange={(e) => {
                            const value = e.target.value;
                            setFormData((prev) => {
                              const prevSubjects = Array.isArray(prev.cia_subjects)
                                ? prev.cia_subjects
                                : [];

                              const nextSubjects = prevSubjects.includes(value)
                                ? prevSubjects.filter((v) => v !== value)
                                : [...prevSubjects, value];

                              const next = {
                                ...prev,
                                cia_subjects: nextSubjects,
                              };

                              localStorage.setItem("formData", JSON.stringify(next));
                              return next;
                            });
                          }}
                        />
                        <label className="form-check-label m-2" htmlFor={`cia-subject-${idx}`}>
                          {label}
                        </label>
                      </div>
                    ))}
                  </div>

                  {errors.cia_subjects && (
                    <div className="text-danger mt-1" style={{ fontSize: "0.9rem" }}>
                      {errors.cia_subjects}
                    </div>
                  )}
                </div>
              )}
              {isEAPartialPlan && (
              <div className="form-group mb-4">
                <label className="mb-2">非全科者，購買科目：（可複選）</label>
                <div className="custom-control custom-checkbox mb-2">
                  {[
                    { id: "part1", label: "Part 1" },
                    { id: "part2", label: "Part 2" },
                    { id: "part3", label: "Part 3" },
                  ].map((item) => (
                    <div key={item.id} className="form-check">
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        id={`ea-part-${item.id}`}
                        value={item.label}
                        checked={Array.isArray(formData.ea_parts) && formData.ea_parts.includes(item.label)}
                        onChange={(e) => {
                          const value = e.target.value;
                          setFormData((prev) => {
                            const prevParts = Array.isArray(prev.ea_parts) ? prev.ea_parts : [];
                            const nextParts = prevParts.includes(value)
                              ? prevParts.filter((v) => v !== value)
                              : [...prevParts, value];

                            const next = { ...prev, ea_parts: nextParts };
                            localStorage.setItem("formData", JSON.stringify(next));
                            return next;
                          });
                        }}
                      />
                      <label className="custom-control-label m-2" htmlFor={`ea-part-${item.id}`}>
                        {item.label}
                      </label>
                    </div>
                  ))}
                </div>

                {errors.ea_parts && (
                  <div className="text-danger mt-1" style={{ fontSize: "0.9rem" }}>
                    {errors.ea_parts}
                  </div>
                )}
              </div>
            )}
              {isEABookPlan && (
                <div className="form-group mb-4">
                  <label className="mb-2">是否需要郵寄紙本書？</label>
                  <div>
                    <div className="form-check form-check-inline">
                      <input
                        type="radio"
                        className="form-check-input"
                        id="ea-book-yes"
                        name="eaBookNeed"
                        checked={showCourses === true}
                        onChange={() => handleAddBookToggle(true)}
                      />
                      <label className="form-check-label" htmlFor="ea-book-yes">
                        是
                      </label>
                    </div>

                    <div className="form-check form-check-inline">
                      <input
                        type="radio"
                        className="form-check-input"
                        id="ea-book-no"
                        name="eaBookNeed"
                        checked={showCourses === false}
                        onChange={() => handleAddBookToggle(false)}
                      />
                      <label className="form-check-label" htmlFor="ea-book-no">
                        否
                      </label>
                    </div>
                  </div>
                </div>
              )}
              {isEABookPlan && showCourses && (
                <div className="form-group mb-4">
                  <label className="mb-2">請選擇寄送方式</label>
                  <div>
                    <div className="form-check form-check-inline">
                      <input
                        type="radio"
                        className="form-check-input"
                        id="ea-deliver-courier"
                        name="eaDeliver"
                        checked={Array.isArray(formData.deliver) && formData.deliver.includes("快遞")}
                        onChange={() => handleDeliverChange("快遞")}
                      />
                      <label className="form-check-label" htmlFor="ea-deliver-courier">
                        快遞
                      </label>
                    </div>

                    <div className="form-check form-check-inline">
                      <input
                        type="radio"
                        className="form-check-input"
                        id="ea-deliver-pickup"
                        name="eaDeliver"
                        checked={Array.isArray(formData.deliver) && formData.deliver.includes("自取")}
                        onChange={() => handleDeliverChange("自取")}
                      />
                      <label className="form-check-label" htmlFor="ea-deliver-pickup">
                        自取
                      </label>
                    </div>
                  </div>
                </div>
              )}
              {isEABookPlan && showCourses && Array.isArray(formData.deliver) && formData.deliver.includes("快遞") && (
                <div className="form-group mb-4">
                  <label className="mb-2">請選擇要寄送的書本</label>
                  <small>便利袋快遞費每箱新台幣 100 元（裝有三科共三本教科書）</small>
                  <div className="custom-control custom-checkbox mb-2">
                    {eaBookOptions.map((item) => (
                      <div key={item.id} className="form-check">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          id={`ea-book-${item.id}`}
                          value={item.label}
                          checked={Array.isArray(formData.book) && formData.book.includes(item.label)}
                          onChange={handleBookChange}
                        />
                        <label className="custom-control-label m-2" htmlFor={`ea-book-${item.id}`}>
                          {item.label}
                        </label>
                      </div>
                    ))}
                  </div>

                  {errors.book && (
                    <div className="text-danger mt-1" style={{ fontSize: "0.9rem" }}>
                      {errors.book}
                    </div>
                  )}
                </div>
              )}
              {/* ===== 發票 ===== */}
              <div className="form-group mb-4">
                <label className="mb-2">發票開立統一編號與抬頭</label>
                <input
                  type="text"
                  className="form-control mb-2"
                  id="tax_num"
                  placeholder="統一編號"
                  pattern="[0-9]*"
                  maxLength={8}
                  inputMode="numeric"
                  value={formData.tax_num}
                  onChange={(e) => setFormData({ ...formData, tax_num: e.target.value })}
                />
                {errors.tax_num && (
                  <div className="text-danger mt-1" style={{ fontSize: "0.9rem" }}>
                    {errors.tax_num}
                  </div>
                )}
                <input
                  type="text"
                  className="form-control"
                  id="company"
                  placeholder="公司抬頭"
                  value={formData.company}
                  onChange={(e) => setFormData({ ...formData, company: e.target.value })}
                />
                <small id="invoiceHelp" className="form-text text-muted">留白則為一般二聯式發票</small>
              </div>

              {!isTEPB && (
                <div className="form-group mb-4">
                  <label htmlFor="address" className="mb-2 me-5">*發票/紙本教科書郵寄地址</label>
                  <label>
                    <input
                      type="checkbox"
                      checked={isForeignAddress}
                      onChange={(e) => handleForeignToggle(e.target.checked)}
                    />
                    國外地址
                  </label>
                  {!isForeignAddress ? (
                    <Address
                      onAddressChange={(combinedAddress) => {
                        const next = { ...formData, address: combinedAddress };
                        setFormData(next);
                        localStorage.setItem("formData", JSON.stringify(next));
                      }}
                    />
                  ) : (
                    <div>
                      <input
                        type="text"
                        name="foreign_address"
                        className="form-control"
                        placeholder="請輸入完整國外地址（英文）"
                        value={formData.foreign_address || ""}
                        onChange={(e) =>
                          setFormData((prev) => {
                            const next = { ...prev, foreign_address: e.target.value };
                            localStorage.setItem("formData", JSON.stringify(next));
                            return next;
                          })
                        }
                      />
                    </div>
                  )}
                  {errors.address && (
                    <div className="text-danger mt-1" style={{ fontSize: "0.9rem" }}>
                      {errors.address}
                    </div>
                  )}
                  {isForeignAddress && errors.foreign_address && (
                    <div className="text-danger mt-1" style={{ fontSize: "0.9rem" }}>
                      {errors.foreign_address}
                    </div>
                  )}
                </div>
              )}

              {/* ✅ 非 CIA 且非 TEPB 才顯示原本 course 選擇 */}
              {!isCIA && !isTEPB && (
                <div className="form-group mb-4">
                  <label className="mb-2">*選擇上課方式：</label><br />
                  <small className="form-text text-muted">依照個人需求，可複選。</small>

                  {allowOnsite ? (
                    <div className="custom-control custom-checkbox mb-2">
                      <div className="form-check form-check-inline">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          id="course-onsite"
                          value="現場面授"
                          checked={Array.isArray(formData.course) && formData.course.includes("現場面授")}
                          onChange={handleCourseSelection}
                        />
                        <label className="custom-control-label m-2" htmlFor="course-onsite">
                          現場面授
                        </label>
                      </div>
                      <div className="form-check form-check-inline">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          id="course-online"
                          value="雲端教室"
                          checked={Array.isArray(formData.course) && formData.course.includes("雲端教室")}
                          onChange={handleCourseSelection}
                        />
                        <label className="custom-control-label m-2" htmlFor="course-online">
                          雲端教室（線上看課）
                        </label>
                      </div>
                    </div>
                  ) : (
                    <div className="custom-control custom-checkbox mb-2">
                      <div className="form-check form-check-inline">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          id="course-online-only"
                          value="雲端教室"
                          checked={Array.isArray(formData.course) && formData.course.includes("雲端教室")}
                          onChange={handleCourseSelection}
                        />
                        <label className="custom-control-label m-2" htmlFor="course-online-only">
                          雲端教室
                        </label>
                      </div>
                    </div>
                  )}

                  {errors.course && (
                    <div className="text-danger mt-1" style={{ fontSize: "0.9rem" }}>
                      {errors.course}
                    </div>
                  )}
                </div>
              )}

              <label className="mb-2">*您是從何處得知 Becker Taiwan (捷進)</label>
              <div className="custom-control custom-checkbox mb-2">
                {[
                  ["google", "Google"],
                  ["facebook", "Facebook"],
                  ["instagram", "Instagram"],
                  ["line", "LINE"],
                  ["edm", "EDM"],
                  ["親友同事介紹", "親友同事介紹"],
                  ["校園講座", "校園講座"],
                  ["事務所內部宣傳", "事務所內部宣傳"],
                  ["捷運廣告", "捷運廣告"],
                  ["企業內部宣傳", "企業內部宣傳"],
                  ["IMA 協會台北分會", "IMA 協會台北分會"],
                ].map(([val, label]) => (
                  <div key={val} className="form-check form-check-inline">
                    <input
                      type="checkbox"
                      className="custom-control-input"
                      id={val}
                      value={val}
                      onChange={handleinfoChange}
                      checked={Array.isArray(formData.info_way) && formData.info_way.includes(val)}
                    />
                    <label className="custom-control-label m-2" htmlFor={val}>{label}</label>
                  </div>
                ))}
              </div>
              {errors.info_way && (
                <div className="text-danger mt-1" style={{ fontSize: "0.9rem" }}>
                  {errors.info_way}
                </div>
              )}

              <button type="submit" className="btn btn-primary" onClick={handleSubmit}>下一步</button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default Payinfo;